import { isServer } from "shared/constants/isServer";
import {AppTester} from "../../supporting";

const AGEYTOMECH_TEAM_ID = 'f66aeadb6cd14f79b66193bec9df954d';

export interface ITeamEntity {
    title: string,
    titleRu?: string,
    id: string,
    isCurrentContext: () => boolean
    disabled?: boolean,
}

export enum ORGANIZATIONS {
    AGEYTOMESH = "ageytomesh",
    BOOKS = "books",
    PACKAGINGLAB = "packaginglab",
    PRINT = "hsepublishinghouse",
    AILAB = 'hseailab',
    ADCODINGHUB = 'adchub',
    HSEFONTS = 'hsefonts',
    HSEMULTIMEDIA = 'hsemultimedia',
    BRANDBUREAU = 'hsebrandbureau',
    ARTSANDCRAFTS = 'hseartsandcrafts',
    HSELOCAL = 'hselocal',
    HSEPOSTERLAB = 'hseposterlab',
    HSESCREENS = 'hsescreens',
    HSEMUSEUMSLAB = 'hsemuseumslab',
    HSECOLLECTIONS = 'hsecollections',
    HSEPHOTOLAB = 'hsephotolab',
    HSESOUND = 'hsesound',
    EDUDESIGN = 'hseedudesign',
    CREATIVEFUTURES = 'hsecreativefutures',
    CREATIVEDEVELOPMENT = 'hsecreadev',
    IMPRESSIONLAB = 'hseimpressionlab',
    VISUALRESEARCH = 'hsevisualresearch',
    SOCIALMEDIA = 'hsesocialmedia',
    INTERIOR = 'hseinteriorlab',
    DESIGN_FUTURES = 'hsedesignfutures',
    FASHION_LAB = 'hsefashionlab',
    GIFT_LAB = 'hsegiftlab',
    STORE = 'hsestore',
    CREATIVE_CITY = 'hsecreativecity',
    HUB = 'hsecreativehub',
    HSETTO = 'hsetto',
    PR = 'hsemedia',
    HOLIDAYS = 'hseholidays',
    ART_MAGAZINE = 'hseartjournal',
    PORTFOLIO = 'hseportfolio',
    DAFES = 'hsedafes',
    HSE_COMPETITIONS = 'hsecompetitions',
    ONLINE_EDUCATION = 'hseonlineeducation',
    HSE_CREATIVE_MAP = 'hsecreativemap',
    KIDS_SCHOOLS_OF_CREATIVE_INDUSTRIES = 'hseschool',
    HSE_ART_METAVERSE = 'hsemetaverse',
    GAME_FUTURES = 'hsegamefutures',
    HSEILLUSTRATION = 'hseillustration',
    CGLAB = "hsecglab",
    HSECOLAB = "hsecolab",
    HSEGALLERY = "hsegallery",
    LABORATORY = 'hselab',
    GRAPHIC_DESIGN = 'hsegraphics',
    MEDIA_DESIGN = 'hsemediadesign',
}

const safeWindow = isServer ? {
    location: {
        pathname: '/',
    },
} : window;

//todo [МУСОР] убрать отовсюду и удалить

export const ORGANIZATION_LIST: Record<ORGANIZATIONS, ITeamEntity> = {
    [ORGANIZATIONS.LABORATORY]: {
        title: 'HSEDESIGNLAB',
        titleRu: 'лаборатория дизайна',
        id: '0d158b5de5c74a2dbbd9c267e2271a84',
        isCurrentContext: () => safeWindow?.location.pathname?.includes('hselab'),
        disabled: true
    },
    [ORGANIZATIONS.GRAPHIC_DESIGN]: {
        title: 'HSE GRAPHICS',
        titleRu: 'графический дизайн',
        id: '1d86f67dc0374ca2bbc7cac9dc9679ad',
        isCurrentContext: () => safeWindow?.location.pathname?.includes('hsegraphics')
    },
    [ORGANIZATIONS.AGEYTOMESH]: {
        title: 'AGEY TOMESH',
        id: AGEYTOMECH_TEAM_ID,
        isCurrentContext: () => AppTester.isAgeytomesh()
    },
    [ORGANIZATIONS.BOOKS]: {
        title: 'books deziiign',
        id: '9d6cc5732507465c939dd200faa30d89',
        isCurrentContext: () => AppTester.isBooksMain()
    },
    [ORGANIZATIONS.INTERIOR]: {
        title: 'HSE Interior Lab',
        titleRu: 'Дизайн интерьера',
        id: '7db1449021a942c59ceb5c87d159ac84',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.INTERIOR)
    },
    [ORGANIZATIONS.HSEILLUSTRATION]: {
        title: 'hse illustration',
        titleRu: 'Иллюстрация',
        id: 'hseillustration',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEILLUSTRATION),
    },
    [ORGANIZATIONS.PACKAGINGLAB]: {
        title: 'PACKAGING LAB',
        titleRu: 'Дизайн упаковки',
        id: '9d257dd77cc8495a835ff86a7b869827',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.PACKAGINGLAB)
    },
    [ORGANIZATIONS.ADCODINGHUB]: {
        title: 'HSE CODING HUB',
        titleRu: 'Разработка сайтов и приложений',
        id: '644007714a0c43a5b2d276893c137912',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.ADCODINGHUB)
    },
    [ORGANIZATIONS.HSETTO]: {
        title: 'HSE SETTO',
        titleRu: 'HSE SETTO',
        id: 'aceb95f3a303412b945478ac0f4f9142',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSETTO)
    },
    [ORGANIZATIONS.AILAB]: {
        title: 'AI LAB',
        titleRu: 'Лаборатория искусственного интеллекта',
        id: '988a90de4d754725839927364c39a6d1',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.AILAB)
    },
    [ORGANIZATIONS.HSEFONTS]: {
        title: 'HSE FONTS',
        titleRu: 'Шрифтовой дизайн',
        id: '53f62e16d8f446439264522bdf9ab346',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEFONTS)
    },
    [ORGANIZATIONS.HSEMULTIMEDIA]: {
        title: 'HSE MULTIMEDIA',
        titleRu: 'Мультимедиа',
        id: 'aa594addf8f44c94b0fa52b1b4968fb7',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEMULTIMEDIA)
    },
    [ORGANIZATIONS.CGLAB]: {
        title: 'cg lab/watt studio',
        titleRu: 'Компьютерная графика',
        id: 'hsecglab',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.CGLAB)
    },
    [ORGANIZATIONS.HSECOLAB]: {
        title: 'student lab',
        titleRu: 'Студенческая лаборатория',
        id: 'hsecolab',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSECOLAB)
    },
    [ORGANIZATIONS.DESIGN_FUTURES]: {
        title: 'DESIGN FUTURES',
        titleRu: 'Предметный дизайн',
        id: 'cbfb6fc0e8724d7ca28e746190960f6b',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.DESIGN_FUTURES)
    },
    [ORGANIZATIONS.FASHION_LAB]: {
        title: 'FASHION FUTURES',
        titleRu: 'Фэшн дизайн',
        id: 'c353f5edf1a245b0b967c724a40bbe03',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.FASHION_LAB)
    },
    [ORGANIZATIONS.GAME_FUTURES]: {
        title: 'GAME FUTURES',
        titleRu: 'Games lab',
        id: '39c122550d7040b4a0cb062b8d3ce8d9',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.GAME_FUTURES)
    },
    [ORGANIZATIONS.GIFT_LAB]: {
        title: 'HSE GIFT LAB',
        titleRu: 'Дизайн подарков',
        id: 'd0432adf9d5a4f5ca162a4aa844b7cff',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.GIFT_LAB)
    },
    [ORGANIZATIONS.BRANDBUREAU]: {
        title: 'Brand Bureau',
        titleRu: 'Бюро студенческих стартапов',
        id: '0a10617f3a724fd1b855541fbfd534eb',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.BRANDBUREAU)
    },
    [ORGANIZATIONS.STORE]: {
        title: 'HSE STORE',
        titleRu: 'Магазин Школы дизайна',
        id: '161ed0e49efb4bf0b03e81cb09638606',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.STORE)
    },
    [ORGANIZATIONS.CREATIVEDEVELOPMENT]: {
        title: 'Сreative Development',
        titleRu: 'Центр креативного девелопмента',
        id: '58c6363dff7f4ea6af41777a71bfb80c',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.CREATIVEDEVELOPMENT)
    },
    [ORGANIZATIONS.HSELOCAL]: {
        title: 'Hse local',
        titleRu: 'Региональные проекты ',
        id: 'd1d1267e01ed4d339ca266240796143c',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSELOCAL),
        disabled: true,
    },
    [ORGANIZATIONS.ARTSANDCRAFTS]: {
        title: 'Handicrafts Research',
        titleRu: 'Центр исследования народных промыслов',
        id: 'c5bd4f18ccda4ef09dd4aac5d8ca85db',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.ARTSANDCRAFTS)
    },
    [ORGANIZATIONS.CREATIVE_CITY]: {
        title: 'CREATIVE CITY',
        titleRu: 'Проект Креативный город',
        id: '16991b82af344481a83fcd4c5679855b',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.CREATIVE_CITY),
        disabled: true
    },
    [ORGANIZATIONS.HUB]: {
        title: 'HSE CREATIVE HUB',
        titleRu: 'Creative Hub',
        id: '29b14e94c8d243539faa872008a421f3',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HUB)
    },
    [ORGANIZATIONS.HSEGALLERY]: {
        title: 'hse art gallery',
        titleRu: 'Hse Art Gallery',
        id: 'hsegallery',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEGALLERY)
    },
    [ORGANIZATIONS.IMPRESSIONLAB]: {
        title: 'Impression Lab',
        titleRu: 'Лаборатория впечатлений',
        id: 'f9a1309111ec446eb3e434ebec6d2952',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.IMPRESSIONLAB)
    },
    [ORGANIZATIONS.ART_MAGAZINE]: {
        title: 'ART JOURNAL',
        titleRu: 'Журнал АРТ',
        id: '58ffddc08a24463680bf35a2221275ee',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.ART_MAGAZINE)
    },
    [ORGANIZATIONS.HSESOUND]: {
        title: 'HSE SOUND',
        titleRu: 'Лаборатория звука',
        id: 'a0e2948c49704ed0a64b31ab0e14284d',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSESOUND)
    },
    [ORGANIZATIONS.HSEPOSTERLAB]: {
        title: 'HSE POSTER LAB',
        titleRu: 'Лаборатория плаката',
        id: 'dddca0c7066a492a9ea553aca554ab7c',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEPOSTERLAB)
    },
    [ORGANIZATIONS.HSEMUSEUMSLAB]: {
        title: 'HSE MUSEUMS LAB',
        titleRu: 'Музейная лаборатория',
        id: 'b2fe97dfbdb54f85b1ad3b8d9593cc28',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEMUSEUMSLAB)
    },
    [ORGANIZATIONS.VISUALRESEARCH]: {
        title: 'Visual Research',
        titleRu: 'Визуальные исследования',
        id: '61e0973be935445699c209e7c5b14198',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.VISUALRESEARCH)
    },
    [ORGANIZATIONS.HSEPHOTOLAB]: {
        title: 'HSE PHOTO LAB',
        titleRu: 'Фотография',
        id: 'e18e0706f73241758bbb1f093185ca65',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEPHOTOLAB)
    },
    [ORGANIZATIONS.HSESCREENS]: {
        title: 'HSE SCREENS',
        titleRu: 'Экранные искусства',
        id: '25c74ef0706f4da59a933dd3400300bb',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSESCREENS),
    },
    [ORGANIZATIONS.PRINT]: {
        title: 'HSE BOOKS',
        titleRu: 'Издательство',
        id: '57e722d8e69447769a013ca0822f1ea7',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.PRINT),
    },
    [ORGANIZATIONS.EDUDESIGN]: {
        title: 'EDUCATIONAL DESIGN',
        titleRu: 'Образовательный дизайн',
        id: '22b7a265765245679f1323482b21b4f7',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.EDUDESIGN)
    },
    [ORGANIZATIONS.HSECOLLECTIONS]: {
        title: 'HSE COLLECTIONS',
        id: '0d89af230a4f434a933a2935b94f9b1f',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSECOLLECTIONS),
        disabled: true,
    },
    [ORGANIZATIONS.CREATIVEFUTURES]: {
        title: 'CREATIVE FUTURES',
        id: '0f4639e29017473d8fc850425bebb807',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.CREATIVEFUTURES),
        disabled: true,
    },
    [ORGANIZATIONS.SOCIALMEDIA]: {
        title: 'SOCIAL MEDIA',
        id: 'a2ebc38c2c724d479a7a20f453f2f22a',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.SOCIALMEDIA),
        disabled: true,
    },
    [ORGANIZATIONS.PR]: {
        title: 'MEDIA',
        id: '8514f416c4fc4e768f83d56c78c44175',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.PR),
        disabled: true,
    },
    [ORGANIZATIONS.HOLIDAYS]: {
        title: 'HOLIDAYS',
        id: 'fd8aa98bf1544178b33bf0dbc5080427',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HOLIDAYS),
        disabled: true,
    },
    [ORGANIZATIONS.PORTFOLIO]: {
        title: 'PORTFOLIO',
        id: '3cd7f79421e14ff49946d3027c0dab4f',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.PORTFOLIO),
        disabled: true,
    },
    [ORGANIZATIONS.DAFES]: {
        title: 'dafes association',
        id: 'df65e07e84f44b99bbad4a63d1b0d85a',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.DAFES),
        disabled: true,
    },
    [ORGANIZATIONS.HSE_COMPETITIONS]: {
        title: 'HSE COMPETITIONS',
        id: 'cb4369264b1d439ebccef3a9dea8d0e5',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSE_COMPETITIONS),
        disabled: true,
    },
    [ORGANIZATIONS.ONLINE_EDUCATION]: {
        title: 'ONLINE EDUCATION',
        id: 'dd695e353cff4b74b2ca0fd7bbac8234',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.ONLINE_EDUCATION),
        disabled: true,
    },
    [ORGANIZATIONS.HSE_CREATIVE_MAP]: {
        title: 'HSE CREATIVE MAP',
        id: '19a2db154184445f863c29bb9d55a0f9',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSE_CREATIVE_MAP),
        disabled: true,
    },
    [ORGANIZATIONS.KIDS_SCHOOLS_OF_CREATIVE_INDUSTRIES]: {
        title: 'kids schools of creative industries',
        id: '3afcc6b91dbe42558979eff46aae5b02',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.KIDS_SCHOOLS_OF_CREATIVE_INDUSTRIES),
        disabled: true,
    },
    [ORGANIZATIONS.HSE_ART_METAVERSE]: {
        title: 'HSE ART METAVERSE',
        id: '54751281795a42b69047ef3ed701978e',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSE_ART_METAVERSE),
        disabled: true,
    },
    [ORGANIZATIONS.MEDIA_DESIGN]: {
        title: 'MEDIA DESIGN',
        titleRu: 'МЕДИА ДИЗАЙН',
        id: '1416452e9bb6472089c1165ebb5e153d',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.MEDIA_DESIGN),
        // disabled: true,
    }
}

export const COURSE_LIST = {
    '9f3e5472fb824b109a86471dc8fbc692': {
        title: 'VIRTUAL SPACES. UNREAL ENGINE',
        titleRu: 'ВИРТУАЛЬНОЕ ПРОСТРАНСТВО НА UNREAL ENGINE',
        id: '9f3e5472fb824b109a86471dc8fbc692',
        isCurrentContext: () => safeWindow?.location.pathname?.includes('9f3e5472fb824b109a86471dc8fbc692')
    },
    '1db605a010ff42628d8b3080961d4134': {
        title: 'GRAPHIC NARRATIVES',
        titleRu: 'ГРАФИЧЕСКИЕ НАРРАТИВЫ',
        id: '1db605a010ff42628d8b3080961d4134',
        isCurrentContext: () => safeWindow?.location.pathname?.includes('1db605a010ff42628d8b3080961d4134')
    },
    'e4e908def842415a8ba8ea8056ecf7e2': {
        title: 'DATA VISUALIZATION. INFOGRAPHICS',
        titleRu: 'ИНФОГРАФИКА И ИЛЛЮСТРИРОВАННЫЕ ДАННЫЕ',
        id: 'e4e908def842415a8ba8ea8056ecf7e2',
        isCurrentContext: () => safeWindow?.location.pathname?.includes('e4e908def842415a8ba8ea8056ecf7e2')
    },
    '7ab0bf0703ec49978adbb1d2aed7ea8d': {
        title: 'Commercial illustration',
        titleRu: 'Коммерческая иллюстрация',
        id: '7db1449021a942c59ceb5c87d159ac84',
        isCurrentContext:  () => safeWindow?.location.pathname?.includes('7ab0bf0703ec49978adbb1d2aed7ea8d')
    },
    'b151266dae5a42269245917b79ec337d': {
        title: 'MUSIC VIDEO MOTION GRAPHICS',
        titleRu: 'МУЗЫКАЛЬНОЕ ГРАФИЧЕСКОЕ ВИДЕО',
        id: 'b151266dae5a42269245917b79ec337d',
        isCurrentContext:  () => safeWindow?.location.pathname?.includes('b151266dae5a42269245917b79ec337d'),
    },
    '1f3f0862f21b4fd29ebc60c6ea205267': {
        title: 'BLENDER',
        titleRu: 'РАБОТА В BLENDER',
        id: '1f3f0862f21b4fd29ebc60c6ea205267',
        isCurrentContext:  () => safeWindow?.location.pathname?.includes('1f3f0862f21b4fd29ebc60c6ea205267'),
    },
    '5766a557cee849699362e1a1a49d3f41': {
        title: 'BUILDING A BRAND',
        titleRu: 'РОЖДЕНИЕ БРЕНДА',
        id: '5766a557cee849699362e1a1a49d3f41',
        isCurrentContext:  () => safeWindow?.location.pathname?.includes('5766a557cee849699362e1a1a49d3f41'),
    },
    'f5d0ac60eb374fd79bb93b52d2c3d43d': {
        title: 'FASHION PHOTOGRAPHY',
        titleRu: 'ФЭШН-СЪЕМКА',
        id: 'f5d0ac60eb374fd79bb93b52d2c3d43d',
        isCurrentContext:  () => safeWindow?.location.pathname?.includes('f5d0ac60eb374fd79bb93b52d2c3d43d'),
    }
}

export const useGetCurrentTeam = (context?: ORGANIZATIONS) => {

    if (context) return ORGANIZATION_LIST[context];

    return Object.values(ORGANIZATION_LIST).find(organization => organization.isCurrentContext()) || null;
}import { isServer } from "shared/constants/isServer";
import {AppTester} from "../../supporting";

const AGEYTOMECH_TEAM_ID = 'f66aeadb6cd14f79b66193bec9df954d';

export interface ITeamEntity {
    title: string,
    titleRu?: string,
    id: string,
    isCurrentContext: () => boolean
    disabled?: boolean,
}

export enum ORGANIZATIONS {
    AGEYTOMESH = "ageytomesh",
    BOOKS = "books",
    PACKAGINGLAB = "packaginglab",
    PRINT = "hsepublishinghouse",
    AILAB = 'hseailab',
    ADCODINGHUB = 'adchub',
    HSEFONTS = 'hsefonts',
    HSEMULTIMEDIA = 'hsemultimedia',
    BRANDBUREAU = 'hsebrandbureau',
    ARTSANDCRAFTS = 'hseartsandcrafts',
    HSELOCAL = 'hselocal',
    HSEPOSTERLAB = 'hseposterlab',
    HSESCREENS = 'hsescreens',
    HSEMUSEUMSLAB = 'hsemuseumslab',
    HSECOLLECTIONS = 'hsecollections',
    HSEPHOTOLAB = 'hsephotolab',
    HSESOUND = 'hsesound',
    EDUDESIGN = 'hseedudesign',
    CREATIVEFUTURES = 'hsecreativefutures',
    CREATIVEDEVELOPMENT = 'hsecreadev',
    IMPRESSIONLAB = 'hseimpressionlab',
    VISUALRESEARCH = 'hsevisualresearch',
    SOCIALMEDIA = 'hsesocialmedia',
    INTERIOR = 'hseinteriorlab',
    DESIGN_FUTURES = 'hsedesignfutures',
    FASHION_LAB = 'hsefashionlab',
    GIFT_LAB = 'hsegiftlab',
    STORE = 'hsestore',
    CREATIVE_CITY = 'hsecreativecity',
    HUB = 'hsecreativehub',
    HSETTO = 'hsetto',
    PR = 'hsemedia',
    HOLIDAYS = 'hseholidays',
    ART_MAGAZINE = 'hseartjournal',
    PORTFOLIO = 'hseportfolio',
    DAFES = 'hsedafes',
    HSE_COMPETITIONS = 'hsecompetitions',
    ONLINE_EDUCATION = 'hseonlineeducation',
    HSE_CREATIVE_MAP = 'hsecreativemap',
    KIDS_SCHOOLS_OF_CREATIVE_INDUSTRIES = 'hseschool',
    HSE_ART_METAVERSE = 'hsemetaverse',
    GAME_FUTURES = 'hsegamefutures',
    HSEILLUSTRATION = 'hseillustration',
    CGLAB = "hsecglab",
    HSECOLAB = "hsecolab",
    HSEGALLERY = "hsegallery",
    LABORATORY = 'hselab',
    GRAPHIC_DESIGN = 'hsegraphics',
    MEDIA_DESIGN = 'hsemediadesign',
}

const safeWindow = isServer ? {
    location: {
        pathname: '/',
    },
} : window;

//todo [МУСОР] убрать отовсюду и удалить

export const ORGANIZATION_LIST: Record<ORGANIZATIONS, ITeamEntity> = {
    [ORGANIZATIONS.LABORATORY]: {
        title: 'HSEDESIGNLAB',
        titleRu: 'лаборатория дизайна',
        id: '0d158b5de5c74a2dbbd9c267e2271a84',
        isCurrentContext: () => safeWindow?.location.pathname?.includes('hselab'),
        disabled: true
    },
    [ORGANIZATIONS.GRAPHIC_DESIGN]: {
        title: 'HSE GRAPHICS',
        titleRu: 'графический дизайн',
        id: '1d86f67dc0374ca2bbc7cac9dc9679ad',
        isCurrentContext: () => safeWindow?.location.pathname?.includes('hsegraphics')
    },
    [ORGANIZATIONS.AGEYTOMESH]: {
        title: 'AGEY TOMESH',
        id: AGEYTOMECH_TEAM_ID,
        isCurrentContext: () => AppTester.isAgeytomesh()
    },
    [ORGANIZATIONS.BOOKS]: {
        title: 'books deziiign',
        id: '9d6cc5732507465c939dd200faa30d89',
        isCurrentContext: () => AppTester.isBooksMain()
    },
    [ORGANIZATIONS.INTERIOR]: {
        title: 'HSE Interior Lab',
        titleRu: 'Дизайн интерьера',
        id: '7db1449021a942c59ceb5c87d159ac84',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.INTERIOR)
    },
    [ORGANIZATIONS.HSEILLUSTRATION]: {
        title: 'hse illustration',
        titleRu: 'Иллюстрация',
        id: 'hseillustration',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEILLUSTRATION),
    },
    [ORGANIZATIONS.PACKAGINGLAB]: {
        title: 'PACKAGING LAB',
        titleRu: 'Дизайн упаковки',
        id: '9d257dd77cc8495a835ff86a7b869827',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.PACKAGINGLAB)
    },
    [ORGANIZATIONS.ADCODINGHUB]: {
        title: 'HSE CODING HUB',
        titleRu: 'Разработка сайтов и приложений',
        id: '644007714a0c43a5b2d276893c137912',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.ADCODINGHUB)
    },
    [ORGANIZATIONS.HSETTO]: {
        title: 'HSE SETTO',
        titleRu: 'HSE SETTO',
        id: 'aceb95f3a303412b945478ac0f4f9142',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSETTO)
    },
    [ORGANIZATIONS.AILAB]: {
        title: 'AI LAB',
        titleRu: 'Лаборатория искусственного интеллекта',
        id: '988a90de4d754725839927364c39a6d1',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.AILAB)
    },
    [ORGANIZATIONS.HSEFONTS]: {
        title: 'HSE FONTS',
        titleRu: 'Шрифтовой дизайн',
        id: '53f62e16d8f446439264522bdf9ab346',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEFONTS)
    },
    [ORGANIZATIONS.HSEMULTIMEDIA]: {
        title: 'HSE MULTIMEDIA',
        titleRu: 'Мультимедиа',
        id: 'aa594addf8f44c94b0fa52b1b4968fb7',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEMULTIMEDIA)
    },
    [ORGANIZATIONS.CGLAB]: {
        title: 'cg lab/watt studio',
        titleRu: 'Компьютерная графика',
        id: 'hsecglab',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.CGLAB)
    },
    [ORGANIZATIONS.HSECOLAB]: {
        title: 'student lab',
        titleRu: 'Студенческая лаборатория',
        id: 'hsecolab',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSECOLAB)
    },
    [ORGANIZATIONS.DESIGN_FUTURES]: {
        title: 'DESIGN FUTURES',
        titleRu: 'Предметный дизайн',
        id: 'cbfb6fc0e8724d7ca28e746190960f6b',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.DESIGN_FUTURES)
    },
    [ORGANIZATIONS.FASHION_LAB]: {
        title: 'FASHION FUTURES',
        titleRu: 'Фэшн дизайн',
        id: 'c353f5edf1a245b0b967c724a40bbe03',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.FASHION_LAB)
    },
    [ORGANIZATIONS.GAME_FUTURES]: {
        title: 'GAME FUTURES',
        titleRu: 'Games lab',
        id: '39c122550d7040b4a0cb062b8d3ce8d9',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.GAME_FUTURES)
    },
    [ORGANIZATIONS.GIFT_LAB]: {
        title: 'HSE GIFT LAB',
        titleRu: 'Дизайн подарков',
        id: 'd0432adf9d5a4f5ca162a4aa844b7cff',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.GIFT_LAB)
    },
    [ORGANIZATIONS.BRANDBUREAU]: {
        title: 'Brand Bureau',
        titleRu: 'Бюро студенческих стартапов',
        id: '0a10617f3a724fd1b855541fbfd534eb',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.BRANDBUREAU)
    },
    [ORGANIZATIONS.STORE]: {
        title: 'HSE STORE',
        titleRu: 'Магазин Школы дизайна',
        id: '161ed0e49efb4bf0b03e81cb09638606',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.STORE)
    },
    [ORGANIZATIONS.CREATIVEDEVELOPMENT]: {
        title: 'Сreative Development',
        titleRu: 'Центр креативного девелопмента',
        id: '58c6363dff7f4ea6af41777a71bfb80c',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.CREATIVEDEVELOPMENT)
    },
    [ORGANIZATIONS.HSELOCAL]: {
        title: 'Hse local',
        titleRu: 'Региональные проекты ',
        id: 'd1d1267e01ed4d339ca266240796143c',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSELOCAL),
        disabled: true,
    },
    [ORGANIZATIONS.ARTSANDCRAFTS]: {
        title: 'Handicrafts Research',
        titleRu: 'Центр исследования народных промыслов',
        id: 'c5bd4f18ccda4ef09dd4aac5d8ca85db',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.ARTSANDCRAFTS)
    },
    [ORGANIZATIONS.CREATIVE_CITY]: {
        title: 'CREATIVE CITY',
        titleRu: 'Проект Креативный город',
        id: '16991b82af344481a83fcd4c5679855b',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.CREATIVE_CITY),
        disabled: true
    },
    [ORGANIZATIONS.HUB]: {
        title: 'HSE CREATIVE HUB',
        titleRu: 'Creative Hub',
        id: '29b14e94c8d243539faa872008a421f3',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HUB)
    },
    [ORGANIZATIONS.HSEGALLERY]: {
        title: 'hse art gallery',
        titleRu: 'Hse Art Gallery',
        id: 'hsegallery',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEGALLERY)
    },
    [ORGANIZATIONS.IMPRESSIONLAB]: {
        title: 'Impression Lab',
        titleRu: 'Лаборатория впечатлений',
        id: 'f9a1309111ec446eb3e434ebec6d2952',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.IMPRESSIONLAB)
    },
    [ORGANIZATIONS.ART_MAGAZINE]: {
        title: 'ART JOURNAL',
        titleRu: 'Журнал АРТ',
        id: '58ffddc08a24463680bf35a2221275ee',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.ART_MAGAZINE)
    },
    [ORGANIZATIONS.HSESOUND]: {
        title: 'HSE SOUND',
        titleRu: 'Лаборатория звука',
        id: 'a0e2948c49704ed0a64b31ab0e14284d',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSESOUND)
    },
    [ORGANIZATIONS.HSEPOSTERLAB]: {
        title: 'HSE POSTER LAB',
        titleRu: 'Лаборатория плаката',
        id: 'dddca0c7066a492a9ea553aca554ab7c',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEPOSTERLAB)
    },
    [ORGANIZATIONS.HSEMUSEUMSLAB]: {
        title: 'HSE MUSEUMS LAB',
        titleRu: 'Музейная лаборатория',
        id: 'b2fe97dfbdb54f85b1ad3b8d9593cc28',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEMUSEUMSLAB)
    },
    [ORGANIZATIONS.VISUALRESEARCH]: {
        title: 'Visual Research',
        titleRu: 'Визуальные исследования',
        id: '61e0973be935445699c209e7c5b14198',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.VISUALRESEARCH)
    },
    [ORGANIZATIONS.HSEPHOTOLAB]: {
        title: 'HSE PHOTO LAB',
        titleRu: 'Фотография',
        id: 'e18e0706f73241758bbb1f093185ca65',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSEPHOTOLAB)
    },
    [ORGANIZATIONS.HSESCREENS]: {
        title: 'HSE SCREENS',
        titleRu: 'Экранные искусства',
        id: '25c74ef0706f4da59a933dd3400300bb',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSESCREENS),
    },
    [ORGANIZATIONS.PRINT]: {
        title: 'HSE BOOKS',
        titleRu: 'Издательство',
        id: '57e722d8e69447769a013ca0822f1ea7',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.PRINT),
    },
    [ORGANIZATIONS.EDUDESIGN]: {
        title: 'EDUCATIONAL DESIGN',
        titleRu: 'Образовательный дизайн',
        id: '22b7a265765245679f1323482b21b4f7',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.EDUDESIGN)
    },
    [ORGANIZATIONS.HSECOLLECTIONS]: {
        title: 'HSE COLLECTIONS',
        id: '0d89af230a4f434a933a2935b94f9b1f',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSECOLLECTIONS),
        disabled: true,
    },
    [ORGANIZATIONS.CREATIVEFUTURES]: {
        title: 'CREATIVE FUTURES',
        id: '0f4639e29017473d8fc850425bebb807',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.CREATIVEFUTURES),
        disabled: true,
    },
    [ORGANIZATIONS.SOCIALMEDIA]: {
        title: 'SOCIAL MEDIA',
        id: 'a2ebc38c2c724d479a7a20f453f2f22a',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.SOCIALMEDIA),
        disabled: true,
    },
    [ORGANIZATIONS.PR]: {
        title: 'MEDIA',
        id: '8514f416c4fc4e768f83d56c78c44175',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.PR),
        disabled: true,
    },
    [ORGANIZATIONS.HOLIDAYS]: {
        title: 'HOLIDAYS',
        id: 'fd8aa98bf1544178b33bf0dbc5080427',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HOLIDAYS),
        disabled: true,
    },
    [ORGANIZATIONS.PORTFOLIO]: {
        title: 'PORTFOLIO',
        id: '3cd7f79421e14ff49946d3027c0dab4f',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.PORTFOLIO),
        disabled: true,
    },
    [ORGANIZATIONS.DAFES]: {
        title: 'dafes association',
        id: 'df65e07e84f44b99bbad4a63d1b0d85a',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.DAFES),
        disabled: true,
    },
    [ORGANIZATIONS.HSE_COMPETITIONS]: {
        title: 'HSE COMPETITIONS',
        id: 'cb4369264b1d439ebccef3a9dea8d0e5',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSE_COMPETITIONS),
        disabled: true,
    },
    [ORGANIZATIONS.ONLINE_EDUCATION]: {
        title: 'ONLINE EDUCATION',
        id: 'dd695e353cff4b74b2ca0fd7bbac8234',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.ONLINE_EDUCATION),
        disabled: true,
    },
    [ORGANIZATIONS.HSE_CREATIVE_MAP]: {
        title: 'HSE CREATIVE MAP',
        id: '19a2db154184445f863c29bb9d55a0f9',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSE_CREATIVE_MAP),
        disabled: true,
    },
    [ORGANIZATIONS.KIDS_SCHOOLS_OF_CREATIVE_INDUSTRIES]: {
        title: 'kids schools of creative industries',
        id: '3afcc6b91dbe42558979eff46aae5b02',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.KIDS_SCHOOLS_OF_CREATIVE_INDUSTRIES),
        disabled: true,
    },
    [ORGANIZATIONS.HSE_ART_METAVERSE]: {
        title: 'HSE ART METAVERSE',
        id: '54751281795a42b69047ef3ed701978e',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.HSE_ART_METAVERSE),
        disabled: true,
    },
    [ORGANIZATIONS.MEDIA_DESIGN]: {
        title: 'MEDIA DESIGN',
        titleRu: 'МЕДИА ДИЗАЙН',
        id: '1416452e9bb6472089c1165ebb5e153d',
        isCurrentContext: () => safeWindow?.location.pathname?.includes(ORGANIZATIONS.MEDIA_DESIGN),
        // disabled: true,
    }
}

export const COURSE_LIST = {
    '9f3e5472fb824b109a86471dc8fbc692': {
        title: 'VIRTUAL SPACES. UNREAL ENGINE',
        titleRu: 'ВИРТУАЛЬНОЕ ПРОСТРАНСТВО НА UNREAL ENGINE',
        id: '9f3e5472fb824b109a86471dc8fbc692',
        isCurrentContext: () => safeWindow?.location.pathname?.includes('9f3e5472fb824b109a86471dc8fbc692')
    },
    '1db605a010ff42628d8b3080961d4134': {
        title: 'GRAPHIC NARRATIVES',
        titleRu: 'ГРАФИЧЕСКИЕ НАРРАТИВЫ',
        id: '1db605a010ff42628d8b3080961d4134',
        isCurrentContext: () => safeWindow?.location.pathname?.includes('1db605a010ff42628d8b3080961d4134')
    },
    'e4e908def842415a8ba8ea8056ecf7e2': {
        title: 'DATA VISUALIZATION. INFOGRAPHICS',
        titleRu: 'ИНФОГРАФИКА И ИЛЛЮСТРИРОВАННЫЕ ДАННЫЕ',
        id: 'e4e908def842415a8ba8ea8056ecf7e2',
        isCurrentContext: () => safeWindow?.location.pathname?.includes('e4e908def842415a8ba8ea8056ecf7e2')
    },
    '7ab0bf0703ec49978adbb1d2aed7ea8d': {
        title: 'Commercial illustration',
        titleRu: 'Коммерческая иллюстрация',
        id: '7db1449021a942c59ceb5c87d159ac84',
        isCurrentContext:  () => safeWindow?.location.pathname?.includes('7ab0bf0703ec49978adbb1d2aed7ea8d')
    },
    'b151266dae5a42269245917b79ec337d': {
        title: 'MUSIC VIDEO MOTION GRAPHICS',
        titleRu: 'МУЗЫКАЛЬНОЕ ГРАФИЧЕСКОЕ ВИДЕО',
        id: 'b151266dae5a42269245917b79ec337d',
        isCurrentContext:  () => safeWindow?.location.pathname?.includes('b151266dae5a42269245917b79ec337d'),
    },
    '1f3f0862f21b4fd29ebc60c6ea205267': {
        title: 'BLENDER',
        titleRu: 'РАБОТА В BLENDER',
        id: '1f3f0862f21b4fd29ebc60c6ea205267',
        isCurrentContext:  () => safeWindow?.location.pathname?.includes('1f3f0862f21b4fd29ebc60c6ea205267'),
    },
    '5766a557cee849699362e1a1a49d3f41': {
        title: 'BUILDING A BRAND',
        titleRu: 'РОЖДЕНИЕ БРЕНДА',
        id: '5766a557cee849699362e1a1a49d3f41',
        isCurrentContext:  () => safeWindow?.location.pathname?.includes('5766a557cee849699362e1a1a49d3f41'),
    },
    'f5d0ac60eb374fd79bb93b52d2c3d43d': {
        title: 'FASHION PHOTOGRAPHY',
        titleRu: 'ФЭШН-СЪЕМКА',
        id: 'f5d0ac60eb374fd79bb93b52d2c3d43d',
        isCurrentContext:  () => safeWindow?.location.pathname?.includes('f5d0ac60eb374fd79bb93b52d2c3d43d'),
    }
}

export const useGetCurrentTeam = (context?: ORGANIZATIONS) => {

    if (context) return ORGANIZATION_LIST[context];

    return Object.values(ORGANIZATION_LIST).find(organization => organization.isCurrentContext()) || null;
}